module.exports = __webpack_public_path__ + "assets/img/portal-window.61622e60.png";